require("./data-list-display.scss");